import axios from "axios";
import React, { useEffect, useState } from "react";
import Button from "../../components/button/button.component";
import "./cart.styles.css";

const formatNumberToPersian = (num) => {
  return num
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") // تفکیک به ازای هر ۳ رقم
    .replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[digit]); // جایگزینی ارقام به فارسی
};

const Cart = () => {
  const [cart, setCart] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    address: "",
    email: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formErrors, setFormErrors] = useState({}); // ذخیره خطاهای فرم

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    const updatedCart = storedCart.map((item) => ({
      ...item,
      price: Number(item.price),
    }));
    setCart(updatedCart);
  }, []);

  const updateLocalStorage = (updatedCart) => {
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCart(updatedCart);
  };

  const increaseQuantity = (id) => {
    const updatedCart = cart.map((item) =>
      item.id === id ? { ...item, quantity: item.quantity + 1 } : item
    );
    updateLocalStorage(updatedCart);
  };

  const decreaseQuantity = (id) => {
    const updatedCart = cart.map((item) =>
      item.id === id && item.quantity > 1
        ? { ...item, quantity: item.quantity - 1 }
        : item
    );
    updateLocalStorage(updatedCart);
  };

  const removeItem = (id) => {
    const updatedCart = cart.filter((item) => item.id !== id);
    updateLocalStorage(updatedCart);
  };

  const handleCouponApply = () => {
    alert(`کوپن "${couponCode}" اعمال شد!`);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fullName.trim()) {
      errors.fullName = "نام کامل الزامی است.";
    }
    if (!formData.address.trim()) {
      errors.address = "آدرس الزامی است.";
    }
    if (!formData.email.trim()) {
      errors.email = "ایمیل الزامی است.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "ایمیل معتبر نیست.";
    }
    if (!formData.phone.trim()) {
      errors.phone = "شماره تماس الزامی است.";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleProceedToCheckout = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      setMessage("در حال ثبت سفارش...");

      // آماده‌سازی داده‌ها برای وب سرویس اول
      const data = new FormData();
      data.append("phone", formData.phone);
      data.append("email", formData.email);
      data.append("full_name", formData.fullName);
      data.append("address", formData.address);
      data.append("campaign_id", "1"); // مقدار ثابت

      // ✅ چاپ مقدار campaign_id قبل از ارسال درخواست
      console.log("First API - campaign_id:", data.get("campaign_id"));

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/login",
        data: data,
      };

      const response = await axios.request(config);
      console.log("Response from first API:", response.data);

      if (response.data.is_status) {
        const accessToken = response.data.data.access_token;

        setMessage("سفارش ثبت شد! در حال انتقال به درگاه پرداخت...");

        // آماده کردن اطلاعات محصولات برای وب سرویس دوم
        const products = cart.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          color: item.colorId, // ارسال کد رنگ
        }));

        const secondApiData = {
          products: products,
          campaign_id: 1, // مقدار ثابت
        };

        // ✅ چاپ مقدار campaign_id و کل داده‌های ارسال شده در کنسول
        console.log("Second API - campaign_id:", secondApiData.campaign_id);
        console.log("Second API - Data Sent:", secondApiData);

        // تنظیمات وب سرویس دوم
        const secondConfig = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/shopping-cart",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          data: JSON.stringify(secondApiData),
        };

        // ارسال درخواست به وب سرویس دوم
        const secondResponse = await axios.request(secondConfig);
        console.log("Response from second API:", secondResponse.data);

        if (secondResponse.data.is_status) {
          // استخراج URL درگاه بانک
          const bankUrl = secondResponse.data.data.url;
          console.log("Bank URL:", bankUrl);

          // خالی کردن سبد خرید
          localStorage.removeItem("cart");
          setCart([]); // به‌روزرسانی وضعیت سبد خرید

          // هدایت کاربر به URL درگاه بانک
          window.location.href = bankUrl;
        } else {
          setMessage("مشکلی در ارتباط با درگاه پرداخت پیش آمد.");
        }
      } else {
        setMessage("مشکلی در ثبت سفارش پیش آمد.");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("خطایی در ثبت سفارش رخ داد.");
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const subtotal = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <div className="cart-container">
      {/* Cart */}
      <div className="container">
        {/* table */}
        <table className="cart-table">
          <thead>
            <tr>
              <th>محصول</th>
              <th>رنگ</th> {/* ستون جدید برای نمایش رنگ */}
              <th>قیمت</th>
              <th>تعداد</th>
              <th>جمع کل</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="product-tabel-items-wrapper">
                    <button
                      className="remove-button"
                      onClick={() => removeItem(item.id)}
                    >
                      ✕
                    </button>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="product-image"
                    />
                    {item.title}
                  </div>
                </td>
                <td>{item.colorName ? item.colorName : "مشخص نشده"}</td>{" "}
                {/* نمایش نام رنگ */}
                <td>{formatNumberToPersian(item.price)} ریال</td>
                <td>
                  <div className="quantity-control">
                    <button
                      className="quantity-button"
                      onClick={() => decreaseQuantity(item.id)}
                    >
                      -
                    </button>
                    <span>{formatNumberToPersian(item.quantity)}</span>
                    <button
                      className="quantity-button"
                      onClick={() => increaseQuantity(item.id)}
                    >
                      +
                    </button>
                  </div>
                </td>
                <td>
                  {formatNumberToPersian(item.price * item.quantity)} ریال
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* coupon */}
        <div className="coupon-section coupon-section-rtl">
          <input
            type="text"
            className="coupon-input"
            placeholder="کد تخفیف"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
          />
          <Button className="coupon-button" onClick={handleCouponApply}>
            اعمال کد
          </Button>
        </div>

        {/* summary */}
        <div className="cart-summary">
          <p>
            جمع کل:{" "}
            <span className="font-family-cart">
              {formatNumberToPersian(subtotal)} ریال
            </span>
          </p>
          <p>
            هزینه ارسال:{" "}
            <span className="font-family-cart">
              {" "}
              با توجه به آدرس کاربر محاسبه میشود{" "}
            </span>
          </p>
          <p>
            مبلغ نهایی:{" "}
            <span className="font-family-cart">
              {formatNumberToPersian(subtotal)} ریال
            </span>
          </p>
        </div>

        {/* دکمه ادامه خرید */}
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "1rem 2rem",
              fontSize: "1.4rem",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = "/checkout";
            }}
          >
            ادامه خرید
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
